export default "__VITE_ASSET__B9o$a7ce__"